module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/BW/hockey-5084e8d0f2b2473960999feddfc429a3.svg";